<template lang="pug">
  div.stu-header.bg-white
    div.W
      //- router-link.logo.fl(:to='{name: "stuIndex"}')
        img(src='@/assets/image/common/logo.png' alt='logo')
      div.flex-aligin-center
        i.el-icon-arrow-left(v-if="showBackBtn" @click="backHandle")
        img#LogoUrl(:src='logoUrl' v-if="logoUrl" ref='logo' @click='handleHome')
        img#LogoUrl(src='/static/images/jf/logo.png' v-else-if="isJF" ref='logo' @click='handleHome')
        img#LogoUrl(src='/static/images/logo_jiaoshiyanxun.png' v-else-if="t2s" ref='logo' @click='handleHome')
        img#LogoUrl(:src='logo' v-else ref='logo' @click='handleHome')
      div.stu-header-linkArea.text-ct(v-if='!t2s && !isJF')
        //- a.fr(@click='changeLang') {{$t('header.lang')}}
        a.fr.f16(href='/static/page/download.html' target='_blank') {{ $t('header.app') }}
        a.fr.f16(href='/static/page/about.html' target='_blank') {{ $t('header.about') }}
      div.stu-header-linkArea.text-ct(v-if='isJF')
        label.fr.f16(@click="go2instructionJF") {{ $t('header.instruction') }}
    div.stu-header-tip.browser-tip(v-if="platform === 'windows' && browser.name !== 'Chrome' && !isJF")
      p {{$t('header.tip_windows')}}
      a(:href='resUrl + "/guide/360Browse.exe"')
        i.icon-360
        | {{$t('header.browser360')}}
      a(:href='resUrl + "/guide/QQBrowser.exe"')
        i.icon-qq
        | {{$t('header.browserqq')}}
      b(@click="platform = ''")
    div.stu-header-tip.browser-tip(v-if="platform === 'mac' && browser.name !== 'Safari'")
      p {{$t('header.tip_mac')}}
      b(@click="platform = ''")
</template>

<script>
export default {
  name: 'Header',
  props: {
    disabledToHome: {
      default: false
    },
    logoUrl: {
      default: ''
    },
    showBackBtn: {
      default: false
    }
  },
  data() {
    return {
      resUrl: localStorage.getItem('resUrl'),
      t2s: localStorage.getItem('t2s'),
      isJF: this.$store.state.isJF,
      logo: window.ConfigNew.logoUrl('logo.stu.png'),
      platform: this.$util.osCheck(),
      browser: this.$util.browserCheck()
    }
  },
  methods: {
    handleHome() {
      if (!this.disabledToHome) {
        this.$router.push({ name: 'stuIndex' })
      }
    },
    changeLang() {
      if (this.$i18n.locale === 'zh') {
        this.$i18n.locale = 'tw'
      } else {
        this.$i18n.locale = 'zh'
      }
    },
    go2instructionJF() {
      this.$winOpen('/static/page/instructionJF.html')
    },
    backHandle() {
      if (localStorage.getItem('sourceType') === 'flutter') {
        window.closeForFlutter && window.closeForFlutter.postMessage('closeForFlutter')
      } else {
        window.external && window.external.onBack()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.flex-aligin-center {
  display: flex;
  align-items: center;
  .el-icon-arrow-left {
    cursor: pointer;
    font-size: 30px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Stu/header.vue